












import { Component } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { TransitionType } from '@/config/enum';
import transitionModule from '@/store/modules/common/transition.module';
import menuModule from '@/store/modules/common/menu.module';
import VMenu from '@/components/menu/VMenu.vue';
import VTopNav from '@/components/menu/VTopNav.vue';
import VMessage from '@/components/items/VMessage.vue';
import authModule from '@/store/modules/common/auth.module';

@Component({
  name: 'main-layout',
  components: { VMessage, VTopNav, VMenu }
})
export default class MainLayout extends Mixin {
  get transitionType(): TransitionType {
    return transitionModule.transitionType;
  }

  get user() {
    return authModule.user;
  }

  mounted() {
    if (!authModule.user) {
      authModule.getAdminInfo();
    }

    menuModule.updateMenuStatus(!this.isSmallScreen());
  }
}
